var invoker = require('./invoker');


/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */
module.exports = invoker(0, 'toUpperCase');



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/toUpper.js
// module id = ./node_modules/ramda/src/toUpper.js
// module chunks = 53 54 55